import { render } from "./direccion_form.vue?vue&type=template&id=0ad01d50"
import script from "./direccion_form.vue?vue&type=script&lang=js"
export * from "./direccion_form.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__